import { Observable } from "rxjs";

export interface FilterConfig {
  key: string;
  label: string;
  type: FilterType;
  placeholder?: string;
  required?: boolean;
  width?: string;
  order?: number;
  options?: FilterOption[] | (() => Promise<any[]>);
  validators?: any[];
  defaultValue?: any;
  dependencies?: FilterDependency[];
  groupedOptions?: FilterOptionGroup[];
}

export interface FilterOptionGroup {
  name: string;
  options: FilterOption[];
}

export interface FilterOption {
  value: any;
  label: string;
  disabled?: boolean;
}

export interface FilterDependency {
  dependsOn: string;
  condition: (value: any) => boolean;
  action: 'show' | 'hide' | 'enable' | 'disable';
}

export enum FilterType {
  TEXT = 'text',
  NUMBER = 'number',
  EMAIL = 'email',
  SELECT = 'select',
  MULTI_SELECT = 'multi-select',
  GROUP_SELECT = 'group_select', 
  DATE = 'date',
  DATE_RANGE = 'date-range',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  TEXTAREA = 'textarea',
  AUTOCOMPLETE = 'autocomplete'
}

export interface FilterData {
  [key: string]: any;
}
